import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const Checkbox = ({ handler, className, checked, label, ...props }) => {

  const [checkedInternal, setCheckedInternal] = useState(checked)
  const onClicked = (e) => {
    e.preventDefault()
    handler(e, !checkedInternal)
    setCheckedInternal(!checkedInternal)
  }

  useEffect(()=> {
    setCheckedInternal(checked)
  }, [checked])

  return (
    <button
      className   = {`checkbox-custom ${className ? className : ''}${checkedInternal ? ' checked' : ''}`}
      aria-label  = {label}
      onClick     = {onClicked}
      htmlFor     = {name}
      type        = "button"
      role        = "checkbox"
      tabIndex    = "0"
      aria-checked = {checkedInternal}
      {...props}
      >
      <div
        className = {'checkbox-icon'}
        >
        {checkedInternal && <i className="fas fa-check" />}
      </div>
      <label>{label}</label>
    </button>
  )
}

Checkbox.defaultProps = {
  checked: false
}

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  handler: PropTypes.func.isRequired,
  normalize: PropTypes.func,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string
}

export default Checkbox
